import type { TenderFormAnswerEvaluationProgressStatus } from '../../api/interfaces';

/**
 * How an evaluation status reads to the applicant.
 *
 * Shared so the evaluation tab and the global tracker never label the same run differently — they are
 * routinely on screen together. It lives beside `isEvaluationInProgress` for the same reason: one
 * definition of what a status means.
 */
export const EVALUATION_STATUS_LABELS: Record<
  TenderFormAnswerEvaluationProgressStatus,
  string
> = {
  NotRequested: 'Non richiesta',
  Queued: 'In coda',
  Scoring: 'Calcolo punteggio',
  Evaluating: 'Valutazione',
  Completed: 'Completata',
  Failed: 'Errore',
};

/** Badge colours for a status, matching the labels above. */
export function evaluationStatusClass(
  status: TenderFormAnswerEvaluationProgressStatus | undefined,
): string {
  if (status === 'Completed') return 'bg-green-100 text-green-700';
  if (status === 'Failed') return 'bg-red-100 text-red-700';
  return 'bg-blue-100 text-blue-700';
}
